import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { ErrorRecoveryActions } from "./error-recovery-actions";
import { NotFound } from "./NotFound";

export const ErrorPage = () => {
  const error = useRouteError();
  console.error(error);

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFound />;
  } else {
    return (
      <div className="flex h-screen flex-col items-center justify-center pb-40">
        {isRouteErrorResponse(error) ? (
          <p className="text-9xl font-bold text-tw-gray-200">{error.status}</p>
        ) : null}
        <h1 className="mt-6 text-xl font-bold text-tw-gray-400">
          エラーが発生いたしました
        </h1>
        <div className="mt-4 text-center leading-relaxed">
          <p>「ページを更新」ボタンをお試しください。</p>
          <p>
            問題が解決しない場合は、お手数ですが担当者までお問い合わせください。
          </p>
        </div>

        <ErrorRecoveryActions className="mt-6" />

        {error instanceof Error && (
          <p className="mt-12 flex max-w-[70dvw] items-start justify-center gap-2 rounded-sm border border-tw-gray-200 bg-tw-gray-50 px-6 py-4">
            <span className="">Error:</span>
            <span>{error.message}</span>
          </p>
        )}
      </div>
    );
  }
};
